import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { setHeader } from '@swapin-hub/api';
import { useLocalStorage } from '@swapin-hub/utils/vueuse';

import { CONFIG_KEY } from '@/const';
import { useConfigStore } from '@/stores/config';
import { useConfig } from '@/queries';

export const useConfigSetup = () => {
  const route = useRoute();
  const router = useRouter();
  const configStore = useConfigStore();

  let configKey = CONFIG_KEY;
  const configUrl = useLocalStorage('swapin-widget-config-url', '');

  if (route.path === '/') {
    configUrl.value = window.location.search;

    const { apiKey } = route.query;

    if (apiKey) {
      configKey = apiKey;
    }
  }

  configStore.key = configKey;
  configStore.url = configUrl.value;

  setHeader('widget-api-key', configKey);

  const { error: configError } = useConfig();

  watch(configError, () => {
    router.push({ name: 'not-available' });
  });
};
